<template>
    <div>
        <p class="step-heading">Step {{ step }} of {{ steps }} - {{ stepName }}</p>
        <div class="step-bar">
            <span v-for="stepNumber in steps" class="step-bar__step"
                  :class="{ 'step-bar__step--active': step >= stepNumber }" :key="stepNumber"></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        steps: {
            type: Number,
            required: true
        },
        step: {
            type: Number,
            required: true
        },
        stepName: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.step-heading {
    font-size: 15px;
    color: #0093D6;
    font-weight: 600;
    margin-bottom: 12px;
}

.step-bar {
    display: flex;
    gap: 15px;
    align-items: center;

    &__step {
        //width: 20%;
        flex: 1;
        height: 2px;
        background-color: #D1D1D1;
        border-radius: 16px;

        &--active {
            height: 4px;
            background-color: #0093D6;
        }
    }
}
</style>
